import React, { Component } from 'react';
import { Redirect } from "react-router-dom";
import logo_img from './../assets/images/Muvi_Logo_Blue_White.svg';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
class ChangePassword extends Component {
  constructor(props) {
		super(props);
    var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
    var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
    this.state = {
      newpassword: '',
      repassword: '',
      redirect: false,
      message: '',
			fields: {},
			errors: {},
      isLoggedIn: false,
      incorrect_password: '',
      expired_link: '',
      //userAuthKey:localStorage.getItem('userAuthKey'),
      apiUrl: this.decryptconfigdata('apiUrl'),
    }
this.resetPassword = this.resetPassword.bind(this);
this.onChange = this.onChange.bind(this);
this.logout = this.logout.bind(this);
	}

  decryptconfigdata(configkey) {
    var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
    var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
    var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
      iv
    });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return plaintext;

  }

  decrypt(findresponse, flg) {
    var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
    var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
    var res = flg ? findresponse.encdata : findresponse;
    var bytes = CryptoJS.AES.decrypt(res, key, {
      iv
    });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(plaintext);
  }

  logout() {
    localStorage.setItem('userLogin', '');
      localStorage.clear(); 
      <Redirect to={'/login'} />
      window.parent.location = window.parent.location.href;
    }
	
  handleValidation() {
		let fields = this.state.fields;
		let errors = {};
		let formIsValid = true;
		console.log(this.state.fields);
    if (!fields["newpassword"]) {
			 formIsValid = false;
			 errors["newpassword"] = "This field is required.";
		}
    if (!fields["repassword"]) {
				formIsValid = false;
				errors["repassword"] = "This field is required.";
    }
    // if(fields["repassword"] != fields["newpassword"]){
    //   formIsValid = false;
    //   errors["repassword"] = "Passwords are not matching.";
    // }
    // if(!this.props.match.params.hashkey){
    //   formIsValid = false;
    //   errors["repassword"] = "Link Has Been Expired.";
    // }
		
    this.setState({ errors: errors });
	 return formIsValid;
}

  resetPassword() {
    if (this.handleValidation()) {
    console.log("Data Has been submitted");
    //return true;
    } else {
    console.log("This Fields Are required.")
    return false;
  }
  const fd = new FormData;
  fd.append('employee_inputs', JSON.stringify(this.state));
    fetch(this.state.apiUrl + '/HrmanagementRest/ResetPassword/hashkey/' + this.props.match.params.hashkey + '/userAuthKey/' + this.props.match.params.userAuthKey, {
       method: 'POST',
       dataType: 'json',
       body: fd,
   })
      .then((Response) => Response.json())
      .then((findresponse) => {
        findresponse = this.decrypt(findresponse, 1);
        if (findresponse.code == 200) {
          window.location.href = '/login';
           } 
        if (findresponse.code == 300) {
          this.setState({ expired_link: findresponse.msg, incorrect_password: '' }, function () { });
          }
        if (findresponse.code == 500) {
          this.setState({ incorrect_password: findresponse.msg, expired_link: '' }, function () { });
          }
   })

  }
  onChange(e) {
		let fields = this.state.fields;
    this.setState({ [e.target.name]: e.target.value });
		fields[e.target.name] = e.target.value;   
  }

  componentDidMount() {
    if (localStorage.getItem('userLogin')=='yes') {
        this.setState({ redirect: true });
    }
  }
  render() {
  // if(this.state.redirect) {
  //   return (
  //     <Redirect to={'/changePassword'} />
  //   )
  // }
  // if(localStorage.getItem('userLogin')){
  //   return (
  //     <Redirect to={'/changePassword'} />
  //   ) 
  // }
    if (this.state.redirect) {
    return (
				<Redirect to={'/login'} />
			)
		}
    return (

    <div class="limiter">
		<div class="logo">
          <a href="#"><img src={logo_img} /></a>
		</div>
		<div class="container-login100">
			<div class="wrap-login">
				<div class="login100-form validate-form">
            <form action="javascript:void(0);" onSubmit={() => this.resetPassword()}>
					<span class="login100-form-title">
					Change Password
					</span>
					<span class="txt1">
          		New Password
					</span>
					<div class="wrap-input100" data-validate="Username is required">
						{/* <input class="input100" type="text" name="username"/> */}
            <input type="password" name="newpassword" class="input100" onChange={this.onChange} />
						<span class="error">{this.state.errors["newpassword"]}</span>
					</div>
					
					<span class="txt1">
						Retype Password
					</span>
					<div class="wrap-input100 validate-input" data-validate="Password is required">
						{/* <input class="input100" type="password" name="pass"/> */}
            <input type="password" name="repassword" class="input100" onChange={this.onChange} />
						<span class="error">{this.state.errors["repassword"]}</span>
            
					</div>

          <span className="error"> {this.state.message}</span>
					<div class="container-login100-form-btn">
                <button type="submit" class="login100-form-btn btn btn-sky">Submit</button>
               
          </div>
          <span class="error">{this.state.incorrect_password}</span>
          <span class="error">{this.state.expired_link}</span>
              </form>
				</div>
			</div>
		</div>
	</div>
  )
}

}

export default ChangePassword;



// WEBPACK FOOTER //
// ./src/components/ChangePassword.js